var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E8F0FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4948_14513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4856 19.6216L28.3841 18.9273L19.2383 25.956L18.3024 25.0201L27.6818 17.813L27.401 15.3362C27.3668 15.0317 27.1266 14.7915 26.8234 14.7587L24.1761 14.4581L17.1277 23.8467L16.1919 22.9095L23.3137 13.4212L23.0118 10.7423C22.9935 10.5625 22.8976 10.3984 22.7533 10.2908C22.6089 10.1832 22.4251 10.1386 22.2466 10.1701L18.5348 10.8263C18.2972 10.8683 18.1029 11.035 18.0255 11.2634L14.3622 22.227L13.2715 23.3177L18.8393 28.8855L19.9287 27.7961L30.8923 24.1328C31.1154 24.058 31.2821 23.8703 31.3281 23.6393L31.9843 20.3921C32.0565 20.043 31.8347 19.7004 31.4856 19.6216Z",
    fill: "#002953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3444 24.248L12.1527 24.4397C10.6184 25.9753 10.6184 28.4718 12.1527 30.0075C12.8956 30.7517 13.8853 31.1612 14.9366 31.1612C15.988 31.1612 16.9776 30.7504 17.7205 30.0075L17.9121 29.8158L12.3444 24.248Z",
    fill: "#002953"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4948_14513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.fb85b7901ee52dfe9d6174edbb4de5ad.svg";
export { ForwardRef as ReactComponent };